import React, { useState } from "react";
 import {
  Table,
  Button as But,
  Modal,
  Spin,
  notification,
  Form,
  Row,
  Col,
} from "antd";
import DropDown from "../ReportFormGenerator/DropDown/DropDown";
import Button from "../ReportFormGenerator/Button/Button";
import Idame from "../ReportFormGenerator/Idame/Idame";
import Date from "../ReportFormGenerator/Date/Date";
import moment from "moment";
import StablePrime from "../Tables/StablePrime";

const productionTableStyle = {
  marginTop: "1rem",
  marginBottom: "1rem",
};

function EnergyReport(props) {
  const [form] = Form.useForm();
  const [FormData, setFormData] = useState(null);
  props.setPageHeader("Energy Report");
  const onFinish = (values) => {
    values["dt"] = values["dt"].format("YYYY/MM/DD").toString();
    //   values["nxtDt"] = values["nxtDt"].format("YYYY/MM/DD").toString();

    setFormData(values);
    
  };
  const Tables = () => {
    if (FormData) {
      return (
        <>
          {FormData ? (
            <div style={productionTableStyle}>
              <StablePrime
                url="/report/energy/part"
                data={FormData}
                identity="energyPart"
              />
            </div>
          ) : (
            <></>
          )}
          {FormData ? (
            <div style={productionTableStyle}>
              <StablePrime
                url="/report/energy/shift"
                data={FormData}
                identity="energyShift"
              />
            </div>
          ) : (
            <></>
          )}
        </>
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row justify="center">
              <Col span={12}>
                <Date
                  name="dt"
                  label={"Date"}
                  required={true}
                  //   disabled={disabledList.includes("dt")}
                  defaultValue={moment().format("MMMM DD YYYY, h:mm:ss a")}
                  errorMessage={"Please Select  Date"}
                  placeholder={"Select Date"}
                />
              </Col>
            </Row>
            <Row justify="center">
              <Col span={12}>
                <Idame
                  // width = {100}
                  form={form}
                  type="name"
                  url="/mdict"
                  urlData={{ typ: "Line", subTyp: "idame", includeAll: true }}
                  idName="lid"
                  idLabel="Line Id"
                  idErrorMessage="Please Select Line Id"
                  idRequired={true}
                  idPlaceholder="Select Line Id"
                  nameName="lame"
                  nameLabel="Line Name"
                  nameErrorMessage="Please Select Line Name"
                  nameRequired={true}
                  namePlaceholder="Select Line Name"
                  defaultIdValue="All"
                  defaultNameValue="All"
                />
              </Col>
            </Row>

            <Row justify="center">
              <Col span={12}>
                <DropDown
                  form={form}
                  name="sh"
                  label="Shift"
                  required={true}
                  errorMessage="Please Select Shift"
                  placeholder="Select Shift"
                  defaultValue="All"
                  searchable={true}
                  options={[
                    { label: "All", value: "All" },
                    { label: "A", value: "A" },
                    { label: "B", value: "B" },
                    { label: "C", value: "C" },
                  ]}
                />
              </Col>
            </Row>

            <Row gutter={24} justify="center">
              <Col span={24}>
                <Button
                  marginLeft={"300px"}
                  form={form}
                  cancelButtonText={"Cancel"}
                  submitButtonText={"Submit"}
                  resetButton={true}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <Tables />
    </>
  );
}

export default EnergyReport;
